module.exports = __webpack_public_path__ + "img/2.f89148f3.jpg";